
import Router from 'vue-router'
import index from '@/pages/index'
import HelloWorld from '@/components/HelloWorld'
import raffle from '@/pages/raffle'
import rollName from '@/pages/rollName'


export default new Router({
  routes: [
   {
      path: '/raffle',
      name: 'raffle',
      component: raffle
    },{
      path: '/rollName',
      name: 'rollName',
      component: rollName
    }, {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js